import {
  distributionContentType,
  distributionStatusBadgeType,
  distributionStatusName
} from '@/common/app/modules/recommend/recommendationDistribution'
import { distributionAbCampaignPath, distributionEditPath } from '@/common/app/path'
import { dateTimeStr } from '@/common/form/date'
import { RecommendationDistribution } from '@/common/model/recommend/recommendationDistribution'
import { WidgetContentType } from '@/common/model/recommend/widget'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import TextButton from '@/components/view/atoms/button/TextButton'
import ClickableTableRow from '@/components/view/atoms/table/ClickableTableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text from '@/components/view/atoms/text/Text'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'

interface Props {
  distribution: RecommendationDistribution
}

const RecommendationDistributionListRow = ({ distribution }: Props) => {
  const editPath = distributionEditPath(distribution.site_id, distribution.id)
  const contentType = distributionContentType(distribution)

  return (
    <ClickableTableRow href={editPath}>
      <TableRowItem width={88}>
        <TextButton link={editPath}>{distribution.id}</TextButton>
      </TableRowItem>
      <TableRowItem width={200}>
        <Text size={14}>{distribution.name}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Badge badgeType={distributionStatusBadgeType(distribution.status)}>
          {distributionStatusName(distribution.status)}
        </Badge>
      </TableRowItem>
      <TableRowItem width={128}>
        <Badge size={14} badgeType={BadgeType.SQUARE_TERTIARY_SECONDARY}>
          {contentType ? (contentType === WidgetContentType.PRODUCT ? '商品' : '記事') : '-'}
        </Badge>
      </TableRowItem>
      <TableRowItem width={200}>
        <ItemAlign direction={'horizon'}>
          <Text>{distribution.ab_enabled ? 'あり' : 'なし'}</Text>
          {distribution.ab_campaign && (
            <TextButton
              link={distributionAbCampaignPath(distribution.site_id, distribution.id)}
              arrow
            >
              A/Bテスト結果
            </TextButton>
          )}
        </ItemAlign>
      </TableRowItem>
      <TableRowItem width={188}>
        <Text size={14}>
          {distribution.ab_enabled
            ? distribution.variants.length +
              ' (' +
              distribution.variants.map((s) => s.ab_traffic).join('/') +
              '%)'
            : '1 (100%)'}
        </Text>
      </TableRowItem>
      <TableRowItem width={320}>
        <Text size={14}>
          {distribution.distributes_at
            ? dateTimeStr(distribution.distributes_at, { omitSecond: true })
            : '-'}
        </Text>
      </TableRowItem>
      <TableRowItem width={160}>
        <Text size={14}>
          {distribution.ab_campaign?.completed_at
            ? dateTimeStr(distribution.ab_campaign.completed_at, { omitSecond: true })
            : '-'}
        </Text>
      </TableRowItem>
    </ClickableTableRow>
  )
}

export default RecommendationDistributionListRow
